/* eslint-disable @typescript-eslint/ban-ts-comment */
export const specifiedArraySort = <T>(arr: T[], order: string[], key: string): T[] => {
  return arr.sort((a: T, b: T) => {
    //@ts-ignore
    const index1 = order.indexOf(a[key])
    //@ts-ignore
    const index2 = order.indexOf(b[key])
    if (index1 === -1 && index2 === -1) {
      return -1
    }
    return (index1 > -1 ? index1 : Infinity) - (index2 > -1 ? index2 : Infinity)
  })
}

export default specifiedArraySort
